import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage('密碼和確認密碼不匹配');
      return;
    }
    try {
      const response = await axios.post('https://shopapi.nogi46.me/api/users/register', {
        username,
        email,
        password,
        phone,
      });
      setMessage('註冊成功！3秒後跳轉到登入頁面。');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setMessage('註冊失敗，請稍後再試。');
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h2>註冊</h2>
          {message && <Alert variant="info">{message}</Alert>}
          <Form onSubmit={handleRegister}>
            <Form.Group controlId="formUsername">
              <Form.Label>用戶名</Form.Label>
              <Form.Control
                type="text"
                placeholder="輸入用戶名"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>電子郵件</Form.Label>
              <Form.Control
                type="email"
                placeholder="輸入電子郵件"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>密碼</Form.Label>
              <Form.Control
                type="password"
                placeholder="輸入密碼"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>確認密碼</Form.Label>
              <Form.Control
                type="password"
                placeholder="再次輸入密碼"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formPhone">
              <Form.Label>電話</Form.Label>
              <Form.Control
                type="text"
                placeholder="輸入電話"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              註冊
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
